module.exports = __webpack_public_path__ + "static/logo-large-6a7a1f029662feff6652e42d9465b4c5.png";